import React from 'react'
import PropTypes from 'prop-types'
import {
    fetchUserProfile,
    updateUserProfile,
    resetUpdateUserProfileState,
} from '../../store/user/userAction'
import { useDispatch, useSelector } from 'react-redux'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { useImmer } from 'use-immer'
import { toast } from 'react-toastify'

import Button from 'components/common/Button'
import CustomToast from 'components/common/CustomToast'
import Image from 'components/common/ImageLoader'
import ContactIcon from 'assets/contact-book.svg'

const LoginForm = ({ closeEdit, cancelAction, user }) => {
    const dispatch = useDispatch()
    const [state, setState] = useImmer({
        inputFirstName: user.first_name,
        inputLastName: user.last_name,
        inputUserName: user.username,
    })
    const updateUserProfileState = useSelector(
        (state) => state.user.updateProfile
    )

    if (updateUserProfileState.success) {
        dispatch(resetUpdateUserProfileState())
        dispatch(fetchUserProfile())
        closeEdit()
    }

    if (updateUserProfileState.error) {
        toast(() => (
            <CustomToast toastType="error" message="Something went wrong" />
        ))
    }

    console.log('edit profile updateUserProfileState', updateUserProfileState)
    return (
        <React.Fragment>
            <Formik
                initialValues={{
                    first_name: state.inputFirstName,
                    last_name: state.inputLastName,
                    username: state.inputUserName,
                }}
                validate={(values) => {
                    const errors = {}
                    if (!values.first_name) {
                        errors.first_name = 'Required'
                    } else if (!values.last_name) {
                        errors.last_name = 'Required'
                    } else if (!values.username) {
                        errors.username = 'Required'
                    }

                    return errors
                }}
                onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                        // alert(JSON.stringify(values, null, 2));
                        dispatch(updateUserProfile(values))
                        setSubmitting(false)
                    }, 400)
                }}
            >
                {({ isSubmitting }) => (
                    <Form>
                        <div className="px-2 py-2">
                            <div className="text-gray-900 font-medium title-font text-base sm:text-2xl mb-2 flex items-center justify-between bg-gray-200 px-2 py-2 rounded-md">
                                <div className="flex items-center ">
                                    <span className="pr-2">
                                        {' '}
                                        Personal Details{' '}
                                    </span>
                                    <Image
                                        src={ContactIcon}
                                        width={30}
                                        height={30}
                                    />
                                </div>
                                <div className="flex items-center justify-center sm:block ">
                                    <Button
                                        extendClass="ml-2"
                                        intent="success"
                                        disable={
                                            isSubmitting ||
                                            updateUserProfileState.loading
                                                ? true
                                                : false
                                        }
                                        // loading={isSubmitting ? true : false}
                                        type="submit"
                                    >
                                        Save
                                    </Button>

                                    <Button
                                        extendClass="ml-2"
                                        intent="danger"
                                        onClick={() => {
                                            closeEdit()
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                            <div className="flex items-center flex-wrap w-full">
                                <div className="w-3/12 sm:w-2/12">
                                    {' '}
                                    First name{' '}
                                </div>
                                <div className="pl-1 w-8/12 sm:w-6/12">
                                    {' '}
                                    <Field
                                        className="w-full bg-white rounded border border-gray-400 focus:outline-none focus:border-primary-500 text-base px-3 py-2"
                                        type="text"
                                        name="first_name"
                                        placeholder="Enter your first name"
                                    />
                                    <ErrorMessage
                                        name="first_name"
                                        component="div"
                                        className="text-reds-r500 "
                                    />
                                </div>
                            </div>

                            <div className="flex items-center flex-wrap w-full mt-2">
                                <div className="w-3/12 sm:w-2/12">
                                    {' '}
                                    Last name{' '}
                                </div>
                                <div className="pl-1 w-8/12 sm:w-6/12">
                                    {' '}
                                    <Field
                                        className="w-full bg-white rounded border border-gray-400 focus:outline-none focus:border-primary-500 text-base px-3 py-2"
                                        type="text"
                                        name="last_name"
                                        placeholder="Enter your last name"
                                    />
                                    <ErrorMessage
                                        name="last_name"
                                        component="div"
                                        className="text-reds-r500 "
                                    />
                                </div>
                            </div>

                            <div className="flex items-center flex-wrap w-full mt-2">
                                <div className="w-3/12 sm:w-2/12">
                                    {' '}
                                    Username{' '}
                                </div>
                                <div className="pl-1 w-8/12 sm:w-6/12">
                                    {' '}
                                    <Field
                                        className="w-full bg-white rounded border border-gray-400 focus:outline-none focus:border-primary-500 text-base px-3 py-2"
                                        type="text"
                                        name="username"
                                        placeholder="Enter your username"
                                    />
                                    <ErrorMessage
                                        name="username"
                                        component="div"
                                        className="text-reds-r500 "
                                    />
                                </div>
                            </div>

                            <p class="leading-relaxed text-lg mt-2">
                                Email:{' '}
                                {user?.data?.email ||
                                    'Information not available'}
                            </p>

                            <p class="leading-relaxed text-lg mt-2">
                                Google Auth:{' '}
                                <code className="bg-yellow-200">
                                    {user?.data?.google ||
                                        'Information not available'}
                                </code>
                            </p>
                        </div>
                    </Form>
                )}
            </Formik>
        </React.Fragment>
    )
}

LoginForm.propTypes = {
    submitData: PropTypes.func.isRequired,
}

export default LoginForm
